/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Link, DeleteMessage } from '@insticator/insticator-ui'; // iui-material
import CardDetail from 'pages/dashboard/reports/library/reportcard/carddetail/carddetail';
// utils
import { renderDayLong, renderDayShort } from '@insticator/insticator-ui'; // iui-utils
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/library/reportcard/reportcard_styles';



/* ========== ~~~~~~~~~~ REPORT CARD ~~~~~~~~~~ ========== */
class ReportCard extends Component {
    constructor(props) {
        super(props);
        this.state = { run: false };
    }
    componentDidUpdate(prevProps) {
        if(this.state.run && (prevProps.isLibraryProcessing && !this.props.isLibraryProcessing)) {
            this.setState({ run: false })
        }
    }
    handleDate = (data, type, formatType) => {
        //we need to make a new copy of data before mutating the object
        //this was causing the data to be out of sync when ran through this renderDay function
        //😎 shout out to JavaScript
        let newData = JSON.parse(JSON.stringify(data));
        if(data[type]) {
            //doing all of this so we can put time on a second line underneath date in the reportCard
            if(formatType === 'long'){
                const longFormatSplit = renderDayLong(data[type]).split(',');
                newData[type] = (
                    <span className={'datetime'}>
                        <span className={'date'} >{`${longFormatSplit[0]}, ${longFormatSplit[1]}`}</span>
                        <span className={'time'} >{longFormatSplit[2]}</span>
                    </span>
                )
            } else {
                newData[type] = renderDayShort(data[type]);
            }
        }
        return newData;
    };
    handleProcessing = () => {
        this.setState({ run: true });
    };
    handleCardClick = () => {
        // this.props.editReport();
    };
    render() {
        return(
            <div className={`reportcard ${this.props.classes.reportcard}`} onClick={this.handleCardClick}>
                <div className={`report-header`}>
                    <div className={`report-title`}>
                        <h3>{this.props.data.name}</h3>
                    </div>
                    <div className={`report-controls`}>
                        <Link type={`action`} name={`run`} text={`Run`} color={`white`} action={this.props.runReport} handleClick={this.handleProcessing} icon={`paper-plane`} operation={'run'} processing={this.state.run} />
                        <Link type={`action`} name={`edit`} text={``} color={`supporting`} action={this.props.editReport} icon={`pen`} iconOnly />
                        <Link
                            type={`modal`}
                            name={`delete`}
                            text={``}
                            color={`supporting`}
                            action={<DeleteMessage itemType={'report'} itemName={this.props.data.name} primaryAction={() => this.props.deleteReport()} />}
                            icon={`trash`}
                            iconOnly
                        />
                    </div>
                </div>
                <div className={`report-content`}>
                    <CardDetail type={`creator`} label={`Created by`} data={this.props.data} />
                    <CardDetail type={`createdAt`} label={`Date created`} data={this.handleDate(this.props.data,'createdAt', 'long')} />
                    <CardDetail type={`lastRun`} label={`Last run`} data={this.handleDate(this.props.data,'lastRun', 'long')} />
                    <CardDetail type={`schedule`} label={`Scheduled`} data={this.props.data} />
                    <CardDetail type={`expiresOn`} label={`Expires`} data={this.handleDate(this.props.data, 'expiresOn')} />
                </div>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ReportCard);
